import { useNavigate, useParams } from "react-router-dom";
import CloseIcon from "../../../assets/img/closeIcon.svg";
import UserIcon from "../../../assets/img/user-icon.svg";
import { haveValue } from "../../../helper/common";
import useTranslator from "../../../hooks/useTranslator";

const NewGuarantorsModal = ({
  isOpen,
  onClose,
  guarantorsList,
  user,
  profileId,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  return (
    isOpen && (
      <div className="wrapper-modal" onClick={onClose}>
        <div
          className={`doc-history-popup total-salary-modal share-profile-modal addPropertyModal ${
            isOpen ? "open" : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <span className="drawerIcon" onClick={onClose} />
          <div>
            <div className="doc-history-header">
              <div className="d-flex align-items-center custom-gap-2">
                <img
                  src={CloseIcon}
                  alt=""
                  className="doc-history-close-btn"
                  onClick={onClose}
                />
                <h4 className="custom-modal-heading">{_t("guarantors")}</h4>
              </div>
            </div>
          </div>
          {haveValue(guarantorsList) &&
          Array.isArray(guarantorsList) &&
          guarantorsList.length > 0 ? (
            <div className="allGuarantorsWrapper">
              {guarantorsList.map((guarantor) => (
                <div className="earner-card mb-3" key={guarantor?._id}>
                  <div className="earner-info align-items-center justify-content-between gap-2 d-flex">
                    <div className="align-items-center thumbnail-main-wrapper gap-2 d-flex">
                      <div className="earner-thumbnail-wrapper">
                        <img src={UserIcon} alt="User Icon" />
                      </div>
                      <h4 className="earner-name">
                        {guarantor?.fname} {guarantor?.lname}
                      </h4>
                    </div>
                    <img
                      className="arrow-card cursor-pointer"
                      src="/images/arrow-right-green.svg"
                      onClick={() => {
                        // user?.isParentLL
                        //   ? navigate(
                        //       `/${workspaceId}/profile-property?agencylink=${profileId}&guarantor=${guarantor?._id}`
                        //     )
                        //   :
                        navigate(
                          `/${workspaceId}/profile-property?sharedprofileid=${profileId}&guarantor=${guarantor?._id}`
                        );
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="notSharedText text-center">
              {_t("noGuarantorsFound")}
            </p>
          )}
        </div>
      </div>
    )
  );
};

export default NewGuarantorsModal;
